import { render } from "./JourneyFormComponent.vue?vue&type=template&id=779203e8&scoped=true"
import script from "./JourneyFormComponent.vue?vue&type=script&lang=js"
export * from "./JourneyFormComponent.vue?vue&type=script&lang=js"

import "./JourneyFormComponent.vue?vue&type=style&index=0&id=779203e8&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-779203e8"]])

export default __exports__